module.exports = __webpack_public_path__ + "img/agriculture-environment-square-1.5ed99257.jpg";